import { ImprvCoinsPackageModel } from '@models/imprvCoins';
import { PaymentSessionCreateModel, PaymentSessionModel } from '@models/payments';
import * as Sentry from '@sentry/nextjs';
import { useCallback, useState } from 'react';
import { useImprvApi } from './useImprvApi';

export const usePaymentsService = () => {
  const imprvApi = useImprvApi();
  const [isPendingGetImprvCoinsPackages, setIsPendingGetImprvCoinsPackages] = useState(false);

  const createPaymentSession = useCallback(
    async (data: PaymentSessionCreateModel): Promise<PaymentSessionModel> => {
      try {
        return await imprvApi.createPaymentSession(data);
      } catch (error) {
        Sentry.captureException(error);
        throw error;
      }
    },
    [imprvApi]
  );

  const getImprvCoinsPackages = useCallback(async (): Promise<ImprvCoinsPackageModel[]> => {
    try {
      setIsPendingGetImprvCoinsPackages(true);
      return await imprvApi.getImprvCoinsPackages();
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    } finally {
      setIsPendingGetImprvCoinsPackages(false);
    }
  }, [imprvApi]);

  return { createPaymentSession, getImprvCoinsPackages, isPendingGetImprvCoinsPackages };
};
